import Model from "flarum/Model";

export default class U2DiUserInfo extends Model {}
Object.assign(U2DiUserInfo.prototype, {
  id: Model.attribute("id"),
  email: Model.attribute("email"),
  emailConfirmed: Model.attribute("emailConfirmed"),
  userType: Model.attribute("userType"),
  bmqy: Model.attribute("bmqy"),
  zsxm: Model.attribute("zsxm"),
  zsxm_title: Model.attribute("zsxm_title"),
  zjgw: Model.attribute("zjgw"),
  lxdh: Model.attribute("lxdh"),
  lxdh_wx: Model.attribute("lxdh_wx"),
  lxdh_wx_qr: Model.attribute("lxdh_wx_qr"),
  khh: Model.attribute("khh"),
  yhkh: Model.attribute("yhkh"),
  sfzh: Model.attribute("sfzh"),
  userKey: Model.attribute("key"),
  expireDays: Model.attribute("expireDays"),
  userStatus: Model.attribute("userStatus"),
  userSigned: Model.attribute("userSigned"),
  inviteCode: Model.attribute("inviteCode"),
  userCode: Model.attribute("userCode"),
  userSuffix: Model.attribute("userSuffix"),
  jjType: Model.attribute("jjType"),
  jjTypeValue: Model.attribute("jjTypeValue"),
  currentDate: Model.attribute("currentDate"),
  noExpiration: Model.attribute("noExpiration"),
  infoCount: Model.attribute("infoCount"),
  assignedAt: Model.attribute("assignedAt"),
  u2diUserData: Model.hasOne("u2diUserData"),
  u2diInviteCodeData: Model.hasMany("u2diInviteCodeData"),
});